export enum InsuranceType {
  HEALTH = 'HEALTH',
  TRAVEL = 'TRAVEL',
  BUILDING = 'BUILDING',
  RC_HOUSEHOLD = 'RC_HOUSEHOLD',
  LEGAL_PROTECTION = 'LEGAL_PROTECTION',
  BUSINESS_LEGAL_PROTECTION = 'BUSINESS_LEGAL_PROTECTION',
  BUSINESS_COMPANY_THINGS = 'BUSINESS_COMPANY_THINGS',
  BUSINESS_RC_COMPANY = 'BUSINESS_RC_COMPANY',
  BUSINESS_RC_PROFESSIONAL = 'BUSINESS_RC_PROFESSIONAL',
  BUSINESS_ACCIDENT = 'BUSINESS_ACCIDENT',
  BUSINESS_ACCIDENT_COMPLEMENTARY = 'BUSINESS_ACCIDENT_COMPLEMENTARY',
  BUSINESS_RETIREMENT = 'BUSINESS_RETIREMENT',
  BUSINESS_HEALTH = 'BUSINESS_HEALTH',
  BUSINESS_TRAVEL = 'BUSINESS_TRAVEL',
  BUSINESS_CYBERSECURITY = 'BUSINESS_CYBERSECURITY',
  BUSINESS_RENTAL = 'BUSINESS_RENTAL',
  BUSINESS_CONSTRUCTION = 'BUSINESS_CONSTRUCTION',
  BUSINESS_BUILDING = 'BUSINESS_BUILDING',
  BUSINESS_MOTOR_VEHICLE = 'BUSINESS_MOTOR_VEHICLE',
  BUSINESS_CONSTRUCTION_WARRANTY = 'BUSINESS_CONSTRUCTION_WARRANTY',
  BUSINESS_THIRD_PILLAR = 'BUSINESS_THIRD_PILLAR',
  BUSINESS_FLEET = 'BUSINESS_FLEET',
  BUSINESS_MACHINERY = 'BUSINESS_MACHINERY',
  BUSINESS_MANIFESTATION = 'BUSINESS_MANIFESTATION',
  BUSINESS_LOSS = 'BUSINESS_LOSS',
  BUSINESS_TRANSPORT = 'BUSINESS_TRANSPORT',
  MOTOR_VEHICLE = 'MOTOR_VEHICLE',
  ANIMAL = 'ANIMAL',
  HOUSING_RENTAL = 'HOUSING_RENTAL',
  QUOTATION_REQUEST = 'QUOTATION_REQUEST',
  CONSTRUCTION = 'CONSTRUCTION',
  THIRD_PILLAR = 'THIRD_PILLAR',
  COMPLEMENTARY_HEALTH = 'COMPLEMENTARY_HEALTH',
  BENEFITS_ACCOUNT = 'BENEFITS_ACCOUNT',
  CENTRALISATION = 'CENTRALISATION',
  CANCELLATION = 'CANCELLATION',
  VALUABLE_OBJECTS = 'VALUABLE_OBJECTS',
  POLICY_UPDATE = 'POLICY_UPDATE',
  COLLABORATOR_DECLARATION = 'COLLABORATOR_DECLARATION',
  BUSINESS_TECHNICAL_INSTALLATION = 'BUSINESS_TECHNICAL_INSTALLATION',
  ACCIDENT = 'ACCIDENT',
  HEALTH_ALLOWANCE = 'HEALTH_ALLOWANCE',
}

export const getInsuranceTypeLabel = (
  type: InsuranceType | string | null | undefined
): string => {
  // A cancellation may not name the branch it ends until it is completed.
  if (!type) return '';
  switch (type) {
    case InsuranceType.HEALTH:
      return $localize`Maladie`;
    case InsuranceType.TRAVEL:
      return $localize`Voyage`;
    case InsuranceType.BUILDING:
      return $localize`Bâtiment`;
    case InsuranceType.RC_HOUSEHOLD:
      return $localize`RC Ménage`;
    case InsuranceType.LEGAL_PROTECTION:
      return $localize`Protection juridique`;
    case InsuranceType.BUSINESS_LEGAL_PROTECTION:
      return $localize`Protection juridique entreprise`;
    case InsuranceType.BUSINESS_COMPANY_THINGS:
      return $localize`Choses de l'entreprise`;
    case InsuranceType.MOTOR_VEHICLE:
      return $localize`Véhicule à moteur`;
    case InsuranceType.ANIMAL:
      return $localize`Animal`;
    case InsuranceType.HOUSING_RENTAL:
      return $localize`Caution de loyer`;
    case InsuranceType.QUOTATION_REQUEST:
      return $localize`Demande de devis`;
    case InsuranceType.CONSTRUCTION:
      return $localize`Construction`;
    case InsuranceType.THIRD_PILLAR:
      return $localize`3ème pilier`;
    case InsuranceType.CENTRALISATION:
      return $localize`Centralisation`;
    case InsuranceType.CANCELLATION:
      return $localize`Résiliation`;
    case InsuranceType.VALUABLE_OBJECTS:
      return $localize`Objets de valeurs`;
    case InsuranceType.COMPLEMENTARY_HEALTH:
      return $localize`Maladie complémentaire`;
    case InsuranceType.BENEFITS_ACCOUNT:
      return $localize`Compte de prestations`;
    case InsuranceType.BUSINESS_RC_COMPANY:
      return $localize`RC entreprise`;
    case InsuranceType.BUSINESS_RC_PROFESSIONAL:
      return $localize`RC professionnelle`;
    case InsuranceType.BUSINESS_ACCIDENT:
      return $localize`LAA`;
    case InsuranceType.BUSINESS_ACCIDENT_COMPLEMENTARY:
      return $localize`LAAC`;
    case InsuranceType.BUSINESS_RETIREMENT:
      return $localize`LPP`;
    case InsuranceType.BUSINESS_HEALTH:
      return $localize`IJM`;
    case InsuranceType.BUSINESS_TRAVEL:
      return $localize`Voyage entreprise`;
    case InsuranceType.BUSINESS_CYBERSECURITY:
      return $localize`Cyber`;
    case InsuranceType.BUSINESS_RENTAL:
      return $localize`Caution de loyer`;
    case InsuranceType.BUSINESS_CONSTRUCTION:
      return $localize`Construction entreprise`;
    case InsuranceType.BUSINESS_BUILDING:
      return $localize`Bâtiment entreprise`;
    case InsuranceType.BUSINESS_MOTOR_VEHICLE:
      return $localize`Véhicule à moteur entreprise`;
    case InsuranceType.BUSINESS_CONSTRUCTION_WARRANTY:
      return $localize`Garantie d'ouvrage`;
    case InsuranceType.BUSINESS_THIRD_PILLAR:
      return $localize`3ème pilier entreprise`;
    case InsuranceType.BUSINESS_FLEET:
      return $localize`Flotte entreprise`;
    case InsuranceType.BUSINESS_MACHINERY:
      return $localize`Machines / technique`;
    case InsuranceType.BUSINESS_MANIFESTATION:
      return $localize`Manifestation`;
    case InsuranceType.BUSINESS_LOSS:
      return $localize`Perte d'exploitation`;
    case InsuranceType.BUSINESS_TRANSPORT:
      return $localize`Transport`;
    case InsuranceType.POLICY_UPDATE:
      return $localize`Modification de police`;
    case InsuranceType.COLLABORATOR_DECLARATION:
      return $localize`Déclaration de collaborateur`;
    case InsuranceType.BUSINESS_TECHNICAL_INSTALLATION:
      return $localize`Installation technique`;
    case InsuranceType.HEALTH_ALLOWANCE:
      return $localize`IJM privée`;
    case InsuranceType.ACCIDENT:
      return $localize`LAA privée`;
    default:
      return type;
  }
};

export const getInsuranceTypeIcon = (type: InsuranceType): string => {
  switch (type) {
    case InsuranceType.HEALTH:
      return 'assets/images/doctor.svg';
    case InsuranceType.TRAVEL:
      return 'assets/images/plane.svg';
    case InsuranceType.BUILDING:
      return 'assets/images/construction-brick.svg';
    case InsuranceType.RC_HOUSEHOLD:
      return 'assets/images/broom.svg';
    case InsuranceType.LEGAL_PROTECTION:
      return 'assets/images/key.svg';
    case InsuranceType.BUSINESS_LEGAL_PROTECTION:
      return '';
    case InsuranceType.BUSINESS_COMPANY_THINGS:
      return '';
    case InsuranceType.MOTOR_VEHICLE:
      return 'assets/images/car.svg';
    case InsuranceType.ANIMAL:
      return 'assets/images/paw.svg';
    case InsuranceType.HOUSING_RENTAL:
      return 'assets/images/cash-payment.svg';
    case InsuranceType.QUOTATION_REQUEST:
      return '';
    case InsuranceType.CONSTRUCTION:
      return 'assets/images/house.svg';
    case InsuranceType.THIRD_PILLAR:
      return 'assets/images/cash-payment.svg';
    case InsuranceType.COMPLEMENTARY_HEALTH:
      return 'assets/images/graph.svg';
    case InsuranceType.BENEFITS_ACCOUNT:
      return '';
    case InsuranceType.CENTRALISATION:
      return 'assets/images/merge.svg';
    case InsuranceType.VALUABLE_OBJECTS:
      return 'assets/images/diamond.svg';
    case InsuranceType.CANCELLATION:
      return 'assets/images/scissors-cut.svg';
    case InsuranceType.BUSINESS_RC_COMPANY:
      return '';
    case InsuranceType.BUSINESS_RC_PROFESSIONAL:
      return '';
    case InsuranceType.BUSINESS_ACCIDENT:
      return '';
    case InsuranceType.BUSINESS_RETIREMENT:
      return '';
    case InsuranceType.BUSINESS_HEALTH:
      return '';
    case InsuranceType.BUSINESS_TRAVEL:
      return '';
    case InsuranceType.BUSINESS_CYBERSECURITY:
      return '';
    case InsuranceType.BUSINESS_RENTAL:
      return '';
    case InsuranceType.BUSINESS_CONSTRUCTION:
      return '';
    case InsuranceType.BUSINESS_BUILDING:
      return '';
    case InsuranceType.BUSINESS_MOTOR_VEHICLE:
      return '';
    case InsuranceType.BUSINESS_CONSTRUCTION_WARRANTY:
      return '';
    default:
      return '';
  }
};

/**
 * A picker's order: the labels the reader actually sees, A→Z. The enum's own
 * order is how the branches were added over the years, which reads as random.
 */
export const sortInsuranceTypesByLabel = (
  types: InsuranceType[]
): InsuranceType[] =>
  [...types].sort((x, y) =>
    getInsuranceTypeLabel(x).localeCompare(getInsuranceTypeLabel(y))
  );

/**
 * What a lead can be opened for, personal side. Cancellations are not here: the
 * new aggregate owns them, and « Une demande de résiliation » is the only way in.
 */
export const PERSONAL_INSURANCES = [
  InsuranceType.HEALTH,
  InsuranceType.COMPLEMENTARY_HEALTH,
  InsuranceType.TRAVEL,
  InsuranceType.CENTRALISATION,
  InsuranceType.RC_HOUSEHOLD,
  InsuranceType.MOTOR_VEHICLE,
  InsuranceType.LEGAL_PROTECTION,
  InsuranceType.BUILDING,
  InsuranceType.CONSTRUCTION,
  InsuranceType.THIRD_PILLAR,
  InsuranceType.ANIMAL,
  InsuranceType.VALUABLE_OBJECTS,
  InsuranceType.HOUSING_RENTAL,
  InsuranceType.BENEFITS_ACCOUNT,
  InsuranceType.ACCIDENT,
  InsuranceType.HEALTH_ALLOWANCE,
];

export const BUSINESS_INSURANCES = [
  InsuranceType.BUSINESS_RC_COMPANY,
  InsuranceType.BUSINESS_ACCIDENT,
  InsuranceType.BUSINESS_ACCIDENT_COMPLEMENTARY,
  InsuranceType.BUSINESS_RETIREMENT,
  InsuranceType.BUSINESS_HEALTH,
  InsuranceType.BUSINESS_CONSTRUCTION,
  InsuranceType.BUSINESS_CONSTRUCTION_WARRANTY,
  InsuranceType.BUSINESS_COMPANY_THINGS,
  InsuranceType.BUSINESS_MOTOR_VEHICLE,
  InsuranceType.BUSINESS_CYBERSECURITY,
  InsuranceType.BUSINESS_RENTAL,
  InsuranceType.BUSINESS_LEGAL_PROTECTION,
  InsuranceType.BUSINESS_FLEET,
  InsuranceType.BUSINESS_TRANSPORT,
  InsuranceType.BUSINESS_TECHNICAL_INSTALLATION,
  InsuranceType.BUSINESS_BUILDING,
  InsuranceType.CENTRALISATION,
];
